<template>
  <div>
    <form @submit.prevent>
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-lg-6">
            <base-input
              alternative=""
              required
              :label="$t('name')"
              :placeholder="$t('name')"
              input-classes="form-control-alternative border"
              v-model="model.name"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('name')"
              name="name"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')"
              ><small>{{ errors.first("name") }}</small></span
            >
          </div>
          <div class="col-lg-6">
            <base-input
              alternative=""
              required
              :label="$t('lastname')"
              :placeholder="$t('lastname')"
              input-classes="form-control-alternative border"
              v-model="model.lastname"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('lastname')"
              name="lastname"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('lastname')"
              ><small>{{ errors.first("lastname") }}</small></span
            >
          </div>
          <div :class="!modal ? 'col-lg-6' : 'col-lg-12'">
            <base-input
              alternative=""
              required
              :label="$t('email')"
              :placeholder="$t('email')"
              input-classes="form-control-alternative border"
              v-model="model.email"
              data-vv-validate-on="blur"
              v-validate="'required|email'"
              :data-vv-as="$t('email')"
              name="email"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')"
              ><small>{{ errors.first("email") }}</small></span
            >
          </div>
          <div class="col-lg-6" v-if="!modal">
            <base-input :label="$t('role')" required>
              <v-select
                v-model="model.role"
                class="form-control-alternative border bg-white p-1 rounded"
                :options="roleOptions"
                :placeholder="$t('selected_rol')"
                multiple
                data-vv-validate-on="blur"
                :v-validate="modal ? '' : 'required'"
                :data-vv-as="$t('role')"
                name="role"
                autocomplete="off"
              />
              <span class="text-danger text-sm" v-show="errors.has('role')"
                ><small>{{ errors.first("role") }}</small></span
              >
            </base-input>
          </div>
        </div>
      </div>

      <div class="pl-lg-4">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-lg-6" v-if="!data">
                <base-input
                  alternative=""
                  required
                  :label="$t('password')"
                  :placeholder="$t('password')"
                  input-classes="form-control-alternative border"
                  v-model="model.password"
                  data-vv-validate-on="blur"
                  v-validate="'required|min:8|max:20'"
                  :data-vv-as="$t('password')"
                  type="password"
                  name="password"
                  ref="password"
                  autocomplete="off"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('password')"
                  ><small>{{ errors.first("password") }}</small></span
                >
              </div>
              <div class="col-lg-6" v-if="!data">
                <base-input
                  alternative=""
                  required
                  :label="$t('password_confirmation')"
                  :placeholder="$t('password_confirmation')"
                  input-classes="form-control-alternative border"
                  v-model="model.password_confirmation"
                  data-vv-validate-on="blur"
                  type="password"
                  v-validate="'required|min:8|max:20|confirmed:password'"
                  :data-vv-as="$t('password_confirmation')"
                  name="password_confirmation"
                  autocomplete="off"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('password_confirmation')"
                  ><small>{{
                    errors.first("password_confirmation")
                  }}</small></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <base-button type="primary" class="my-4" @click="add">{{
          $t("save")
        }}</base-button>
      </div>
    </form>
  </div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import { mapActions } from "vuex";
import BaseCheckbox from "@/components/BaseCheckbox.vue";
export default {
  components: { BaseCheckbox },
  name: "create-or-update-user",
  props: {
    data: { default: null },
    modal: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  data() {
    return {
      model: {
        id: "",
        name: "",
        lastname: "",
        email: "",
        role: [],
        password: "",
        password_confirmation: "",
        isAdmin: false
      }
    };
  },
  computed: {
    roleOptions() {
      return [
        { value: 1, label: this.$t("admin") },
        { value: 2, label: this.$t("super_admin") },
        { value: 3, label: this.$t("member") }
      ];
    }
  },
  methods: {
    ...mapActions({
      createOrUpdate: "user/createOrUpdate"
    }),

    async add() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          const {
            id,
            name,
            lastname,
            email,
            password,
            password_confirmation,
            role
          } = this.model;
          let data = {
            id,
            name,
            lastname,
            email,
            password,
            password_confirmation,
            role: []
          };
          if (!this.modal) {
            role.forEach((e, index) => {
              data.role[index] = e.value;
            });
          } else {
            data.role[0] = 3;
          }
          const res = await this.createOrUpdate(data);
          this.$toast.success(res.message, {
            position: "top-right"
          });
          this.modal
            ? this.$emit("close", res.data.id)
            : this.$router.push("/users");
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
